import { catchError, from, mergeMap, of, tap} from "rxjs";
import { getBaseUrl, getTokenFromStorage, showSessionExpiredPopup} from "../taskpane/utils";
import { BatchData, ObjRequest, RequestItem } from "./corpo.model";
import { CustomExcelError } from "./custom.error";
import { clearFormatting } from "./utils";


export function clearBatchCache() {
    Object.keys(cacheDataBatch).forEach(key => delete cacheDataBatch[key]);
}

const cacheDataBatch: Record<string, Promise<BatchData>> = {};
export function processBatchGetDataService(url: string, payload: ObjRequest, requests : RequestItem[], invocation : CustomFunctions.Invocation) {

    let allCached = true;
    const newKeys = new Set<string>();

    requests.forEach(req => {

        const key = `${req.Issuer}-${req.Metric}-${req.Year}-${url}`;

        if (cacheDataBatch[key]) {
            cacheDataBatch[key].then(req.resolve).catch(req.reject);
        } else {
            allCached = false;
            newKeys.add(key);
            cacheDataBatch[key] = new Promise<BatchData>((resolve, reject) => {
                const originalResolve = req.resolve;
                const originalReject = req.reject;
                req.resolve = (val: BatchData) => { resolve(val as BatchData); originalResolve(val as BatchData); };
                req.reject  = (err: any)  => { delete cacheDataBatch[key];  originalReject(err);  };
            });
        }

    });

    if (allCached || newKeys.size === 0) {
        return of(null);
    } 

    const filteredPayload: ObjRequest = newKeys.size !== 0 ? {
        issuerName: payload.issuerName,
        queryData: payload.queryData.filter(q => 
            newKeys.has(`${payload.issuerName}-${q.metricName}-${q.year}-${url}`)
        )
    } : payload;  

    const token = getTokenFromStorage();
    const baseUrl = getBaseUrl();

    const controller = new AbortController();
    (invocation as any).onCanceled = () => controller.abort();

    return from(
        fetch(baseUrl.concat(url), {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify(filteredPayload),
            signal: controller.signal,
        })
    ).pipe(
        mergeMap((response) => {
            return from( response.ok ? response.json() : Promise.reject(response));
        }),
        tap((data: BatchData[]) => {
            requests.forEach((r) => {
                if (r.Issuer === payload.issuerName) {
                    const key = `${r.Issuer}-${r.Metric}-${r.Year}-${url}`;
                    if (!newKeys.has(key)) return;

                    const res = data.find(d => d.issuerName === r.Issuer && d.metricName === r.Metric && d.year === r.Year);

                    if (res) {
                        if (!cacheDataBatch[key]) {
                            cacheDataBatch[key] = Promise.resolve(res);
                        }
                        r.resolve(res);
                    } else {
                        delete cacheDataBatch[key];
                        r.reject(new CustomExcelError(404, CustomFunctions.ErrorCode.notAvailable, "Data not available"));
                    }
                }
            });
        }),
        catchError((err) => {

            requests.filter(r => r.Issuer === payload.issuerName && newKeys.has(`${r.Issuer}-${r.Metric}-${r.Year}-${url}`)) .forEach(async r => {
                const key = `${r.Issuer}-${r.Metric}-${r.Year}-${url}`;

                if (cacheDataBatch[key]) {
                    delete cacheDataBatch[key];
                }

                if (err?.status === 401) {
                    await clearFormatting(invocation.address);
                    showSessionExpiredPopup(
                        "Not authenticated",
                        "Your are not connected <br>Please login to access this data.",
                        "Connect"
                    );
                    r.reject(
                        new CustomExcelError(err?.status,CustomFunctions.ErrorCode.notAvailable,err?.message ?? "CONNECTION EXPIRED")
                    );
                } else {
                    r.reject(
                        new CustomExcelError(err?.status,CustomFunctions.ErrorCode.notAvailable,err?.message ?? "Data not available")
                    );
                }
    
            });

            return of(null);
        })
    );
}